import { timelineNodes } from "@/mocks/guatian";

const stateDot: Record<string, string> = {
  已证实: "bg-primary-500 ring-primary-100",
  待证实: "bg-secondary-500 ring-secondary-100",
  反转节点: "bg-accent-500 ring-accent-100",
  "有争议": "bg-background-400 ring-background-200",
};

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.5fr] lg:gap-14">
          {/* 左侧概要 */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-bold text-primary-700">
              <i className="ri-history-line" aria-hidden="true"></i>
              TIMELINE 编年史
            </div>
            <h2 className="mt-3 text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              一条热点的<br />完整<span className="text-primary-600">三天脉络</span>
            </h2>
            <p className="mt-4 text-sm leading-6 text-foreground-500">
              以本周热度最高的事件为例，把散落在各平台的信息按发生顺序归位，还原从发酵、回应到反转的整个过程。
            </p>
            <div className="mt-6 space-y-3 border-l-2 border-background-200 pl-4">
              <div>
                <p className="text-xs text-foreground-400">事件标签</p>
                <div className="mt-1 flex flex-wrap gap-2">
                  {["直播争议", "片段被剪", "两轮回应", "反转收尾"].map((t) => (
                    <span key={t} className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-600">
                      # {t}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs text-foreground-400">最终结论</p>
                <p className="mt-1 text-sm font-bold text-foreground-800">
                  原始切片致歉删除，方向性反转成立，已归入档案 006。
                </p>
              </div>
            </div>
            <a
              href="#guide"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 text-sm font-bold text-background-50 transition hover:bg-foreground-800"
            >
              学三招避免误读
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          {/* 右侧时间线 */}
          <div className="relative">
            <div className="absolute bottom-4 left-[7px] top-2 w-0.5 bg-background-200"></div>
            <ol className="space-y-8">
              {timelineNodes.map((n) => (
                <li key={n.title} className="relative pl-10">
                  <span
                    className={`absolute left-0 top-1.5 flex h-[15px] w-[15px] items-center justify-center rounded-full ring-4 ${stateDot[n.state]}`}
                  ></span>
                  <div className="rounded-lg border border-background-200 bg-background-50 p-5 transition hover:border-primary-200 md:p-6">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <span className="text-xs font-bold tracking-wide text-primary-700">{n.phase}</span>
                      <span
                        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs ${
                          n.state === "反转节点"
                            ? "border-accent-200 text-accent-700"
                            : n.state === "待证实"
                            ? "border-secondary-200 text-secondary-800"
                            : "border-primary-200 text-primary-700"
                        }`}
                      >
                        {n.state}
                      </span>
                    </div>
                    <h3 className="mt-3 text-lg font-bold text-foreground-950">{n.title}</h3>
                    <p className="mt-2 text-sm leading-6 text-foreground-600">{n.text}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}